import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageDialog from '../../utils/PageDialog';
import { COLORS } from '../rejestracja/formTheme';
import { faqs, cookies, privacy, termsCon } from './TermsData';

const PAGES = {
  faqs: { title: 'page_faqs', items: faqs },
  cookies: { title: 'page_cookies', items: cookies },
  privacy: { title: 'page_privacy', items: privacy },
  tcs: { title: 'page_tcs', items: termsCon },
};

export const Terms = () => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const page = PAGES[slug] ?? PAGES.faqs;
  const items = page.items();

  return (
    <PageDialog title={t(page.title)}>
      <Box>
        {items?.map((item) => (
          <Accordion
            key={item.id}
            disableGutters
            square
            sx={{
              backgroundColor: COLORS.card,
              backgroundImage: 'none',
              color: COLORS.text,
              border: `1px solid ${COLORS.border}`,
              borderRadius: 1.5,
              boxShadow: 'none',
              mb: 1.5,
              '&:before': { display: 'none' },
              '&:first-of-type, &:last-of-type': { borderRadius: 1.5 },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: COLORS.accent }} />}
              sx={{ px: 2, minHeight: 56 }}
            >
              <Typography sx={{ fontWeight: 700 }}>{item.title}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
              {item.body != null && (
                <Typography
                  sx={{ whiteSpace: 'pre-line', color: COLORS.muted, fontWeight: 300 }}
                >
                  {item.body}
                </Typography>
              )}
              {item.inner?.map((inner, i) => (
                <Typography
                  key={i}
                  sx={{
                    whiteSpace: 'pre-line',
                    color: COLORS.muted,
                    fontWeight: 300,
                    mt: 1,
                    pl: 2,
                  }}
                >
                  &#x2022; {inner.body}
                </Typography>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </PageDialog>
  );
};
